<div class="container mainbox">
    <form [formGroup]="mainForm" *ngIf="dataLoaded; else dataLoadingTemplate">
        <h1 class="form-group title-position" style="margin-top: 20px;"
            translate>{{isEdit ? 'sales.edit.title' : 'sales.title'}}</h1>
        <p class="text-muted" translate>{{isEdit ? 'sales.edit.subtitle' : 'sales.subtitle'}}</p>

        <!-- The document stays with the superseded order, so the operator is told before
             they change anything rather than after. -->
        <div class="alert alert-warning" *ngIf="isEdit && hasInvoice" translate>sales.edit.hasInvoice</div>

        <div id="mainContent">

            <!-- ******************************************************
            ************************ Данни ************************
            ****************************************************** -->
            <div class="card">
                <div class="card-header" id="mainSection">
                    <h6 class="mb-0">
                        <span translate>sales.mainSection</span>
                    </h6>
                </div>
                <div id="collapseMainSection" aria-labelledby="mainSection">
                    <div class="card-body">
                        <div class="container-fluid row">

                            <!-- Only shown when the employee works at more than one point: it
                                 decides both the services offered and the iCash store. -->
                            <div class="col-lg-6 col-md-12" *ngIf="!hasSingleTechPoint">
                                <label style="margin-top: 12px;">
                                    <span translate>sales.technicalPoint</span> <span class="text-danger">*</span>
                                </label>
                                <select class="custom-select input-custom-size" formControlName="techPointMobileAppId"
                                    (change)="onTechPointChange()"
                                    [ngClass]="{ 'is-invalid': showValidations && f.techPointMobileAppId.errors }">
                                    <option [ngValue]="null" disabled translate>placeholder.select</option>
                                    <option *ngFor="let id of userTechPointMobileAppIds" [ngValue]="id">{{id}}</option>
                                </select>
                                <div class="invalid-feedback" *ngIf="f.techPointMobileAppId.errors?.required && showValidations" translate>errors.required</div>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <label style="margin-top: 12px;"><span translate>sales.regNumber</span></label>
                                <input type="text" class="form-control" formControlName="regNumber"
                                    placeholder="{{'sales.regNumber.placeholder' | translate}}"
                                    (blur)="onRegNumberBlur()">
                                <small class="form-text text-muted" translate>sales.regNumber.hint</small>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <label style="margin-top: 12px;">
                                    <span translate>sales.rvsCategory</span> <span class="text-danger">*</span>
                                </label>
                                <select class="custom-select input-custom-size" formControlName="rvsCategoryId"
                                    (change)="onCategoryChange()"
                                    [ngClass]="{ 'is-invalid': showValidations && f.rvsCategoryId.errors }">
                                    <option [ngValue]="null" disabled translate>placeholder.select</option>
                                    <option *ngFor="let category of rvsCategories" [ngValue]="category.id">{{category.description}}</option>
                                </select>
                                <div class="invalid-feedback" *ngIf="f.rvsCategoryId.errors?.required && showValidations" translate>errors.required</div>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <label style="margin-top: 12px;"><span translate>sales.identNum</span></label>
                                <div class="input-group">
                                    <input type="text" class="form-control" formControlName="identNum" readonly
                                        placeholder="{{'sales.identNum.placeholder' | translate}}">
                                    <div class="input-group-append">
                                        <button class="btn btn-outline-primary" type="button" (click)="openSubjectModal()" translate>button.choose</button>
                                        <button class="btn btn-outline-danger" type="button" *ngIf="recipient" (click)="clearRecipient()">
                                            <i class="fa fa-times"></i>
                                        </button>
                                    </div>
                                </div>
                                <small class="form-text text-muted" *ngIf="recipient">{{recipient.fullName}}</small>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <label style="margin-top: 12px;"><span translate>sales.promoCode</span></label>
                                <div class="input-group">
                                    <input type="text" class="form-control" formControlName="promoCode"
                                        placeholder="{{'placeholder.enter' | translate}}"
                                        [readonly]="promocodeLoading" (keyup.enter)="applyPromocode()">
                                    <!-- The spinner sits inside the field, so the wait is shown where the
                                         code was typed rather than somewhere else on the form. -->
                                    <div class="input-group-append" *ngIf="promocodeLoading">
                                        <span class="input-group-text bg-transparent border-left-0">
                                            <span class="spinner-border spinner-border-sm" role="status">
                                                <span class="sr-only">Loading...</span>
                                            </span>
                                        </span>
                                    </div>
                                    <div class="input-group-append">
                                        <button class="btn btn-outline-primary" type="button"
                                            [disabled]="promocodeLoading" (click)="applyPromocode()" translate>sales.promoCode.apply</button>
                                    </div>
                                </div>

                                <!-- One chip per code in force, each naming the service it discounts. -->
                                <div class="mt-2" *ngIf="appliedPromocodes.length > 0">
                                    <span class="badge badge-pill badge-success mr-2 mb-1 p-2"
                                        *ngFor="let applied of appliedPromocodes">
                                        {{applied.code}} &middot; {{applied.serviceName}}
                                        <i class="fa fa-times ml-1" style="cursor: pointer;" (click)="removePromocode(applied)"></i>
                                    </span>
                                </div>

                                <!-- The campaigns taking money off this bill. Nothing is applied
                                     by hand, so without these the operator has no way to explain
                                     a discounted price to the customer. -->
                                <div class="mt-2" *ngIf="activeCampaignChips.length > 0">
                                    <span class="badge badge-pill badge-info mr-2 mb-1 p-2"
                                        *ngFor="let campaign of activeCampaignChips">
                                        {{campaign.discountText}} &middot; {{campaign.serviceName}}
                                    </span>
                                </div>

                                <!-- Rejections only, and only for a few seconds: a code that
                                     worked is already visible as a chip above. -->
                                <small class="form-text text-danger" *ngIf="promocodeMessage">{{promocodeMessage}}</small>
                                <small class="form-text text-info" *ngIf="campaignMessage">{{campaignMessage}}</small>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <!-- ******************************************************
            ****************** Допълнителни услуги ******************
            ****************************************************** -->
            <div class="card">
                <div class="card-header" id="servicesSection">
                    <h6 class="mb-0">
                        <span translate>sales.additionalServices</span>
                    </h6>
                </div>
                <div id="collapseServicesSection" aria-labelledby="servicesSection">
                    <div class="card-body">

                        <div class="d-flex justify-content-center" *ngIf="servicesLoading">
                            <div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>
                        </div>

                        <div class="alert alert-info" *ngIf="!servicesLoading && additionalServices.length === 0" translate>
                            sales.additionalServices.none
                        </div>

                        <div class="container-fluid" *ngIf="!servicesLoading">
                            <div class="row align-items-center py-1" *ngFor="let service of additionalServices">
                                <div class="col-8">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input" id="service{{service.id}}"
                                            [checked]="isServiceSelected(service)"
                                            (change)="toggleService(service, $any($event.target).checked)">
                                        <label class="custom-control-label" for="service{{service.id}}">{{service.serviceName}}</label>
                                    </div>
                                </div>
                                <div class="col-2 text-right">
                                    <span class="text-muted">{{(service.priceAttribute?.amountDds || service.amountDds || 0) | number:'1.2-2'}} &euro;</span>
                                </div>
                                <!-- A service the campaign gives away is held at one: the offer is
                                     one of it, not however many are typed. -->
                                <div class="col-2">
                                    <input type="number" min="1" step="1" class="form-control form-control-sm"
                                        *ngIf="isServiceSelected(service)"
                                        [readonly]="isServiceFreeByCampaign(service.id)"
                                        [max]="isServiceFreeByCampaign(service.id) ? 1 : null"
                                        [(ngModel)]="serviceQuantities[service.id]" [ngModelOptions]="{standalone: true}"
                                        (change)="onServiceQuantityChange(service)">
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <!-- ******************************************************
            ********************* Продажба на стоки *******************
            ****************************************************** -->
            <div class="card">
                <div class="card-header" id="goodsSection">
                    <h6 class="mb-0">
                        <span translate>sales.goods</span>
                    </h6>
                </div>
                <div id="collapseGoodsSection" aria-labelledby="goodsSection">
                    <div class="card-body">

                        <input type="text" class="form-control" formControlName="itemSearch"
                            placeholder="{{'sales.goods.placeholder' | translate}}"
                            (input)="onItemSearchChange()">

                        <div class="d-flex justify-content-center mt-2" *ngIf="catalogLoading">
                            <div class="spinner-border spinner-border-sm" role="status"><span class="sr-only">Loading...</span></div>
                        </div>

                        <div class="list-group mt-2" *ngIf="catalogResults.length > 0">
                            <div class="list-group-item" *ngFor="let item of catalogResults">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div>
                                        <div>{{item.name}}</div>
                                        <small class="text-muted">
                                            <span translate>sales.goods.inventoryId</span> {{item.inventoryId}}
                                            &middot; {{item.sellPrice | number:'1.2-2'}} &euro;
                                            <span *ngIf="item.barcode">&middot; <span translate>sales.goods.barcode</span> {{item.barcode}}</span>
                                        </small>
                                    </div>
                                    <div class="d-flex align-items-center" style="gap: 8px;">
                                        <input type="number" min="1" step="1" class="form-control form-control-sm" style="width: 70px;"
                                            [(ngModel)]="itemQuantities[item.saleItemId]" [ngModelOptions]="{standalone: true}">
                                        <!-- Disabled while this row's stock is being read, so the
                                             same article cannot be added twice over one check. -->
                                        <button class="btn btn-sm btn-primary" type="button"
                                            [disabled]="checkingStockForSaleItemId === item.saleItemId"
                                            (click)="addCatalogItem(item)">
                                            <span class="spinner-border spinner-border-sm mr-1"
                                                *ngIf="checkingStockForSaleItemId === item.saleItemId" role="status">
                                                <span class="sr-only">Loading...</span>
                                            </span>
                                            <span translate>sales.goods.add</span>
                                        </button>
                                    </div>
                                </div>
                                <small class="form-text text-danger" *ngIf="itemMessages[item.saleItemId]">
                                    {{itemMessages[item.saleItemId]}}
                                </small>
                            </div>
                        </div>

                        <div class="mt-2" *ngIf="itemLines.length > 0">
                            <span class="badge badge-pill badge-primary mr-2 p-2" *ngFor="let line of itemLines">
                                {{line.quantity}}&times; {{line.name}}
                                <i class="fa fa-times ml-1" style="cursor: pointer;" (click)="removeLine(line)"></i>
                            </span>
                        </div>

                    </div>
                </div>
            </div>

            <!-- ******************************************************
            ************ Касова бележка и дата на продажбата ***********
                 The two sit in one row as equal halves: both are short, and neither fills a
                 card of its own. h-100 keeps them the same height whatever each one holds.
            ****************************************************** -->
            <div class="form-row">
                <div class="col-lg-6 col-md-12">
                    <div class="card h-100">
                        <div class="card-header" id="fiscalSection">
                            <h6 class="mb-0">
                                <span translate>sales.fiscalSection</span>
                            </h6>
                        </div>
                        <div id="collapseFiscalSection" aria-labelledby="fiscalSection">
                            <div class="card-body">
                                <label style="margin-top: 12px;"><span translate>sales.fiscalNumber</span></label>
                                <!-- The green state confirms the seven digits are in, as they are
                                     typed and without waiting for a save: the operator is copying
                                     them off a paper receipt and has no other way to tell they got
                                     all seven. The field stays optional, so an empty box is left
                                     neutral rather than marked either way. -->
                                <input type="text" class="form-control" formControlName="fiscalNumber" maxlength="7"
                                    placeholder="{{'sales.fiscalNumber.placeholder' | translate}}"
                                    [ngClass]="{ 'is-invalid': showValidations && f.fiscalNumber.errors,
                                                 'is-valid': isFiscalNumberComplete }">
                                <div class="invalid-feedback"
                                    *ngIf="f.fiscalNumber.errors?.pattern && showValidations"
                                    translate>errors.fiscalNumberInvalid</div>
                                <div class="valid-feedback d-block" *ngIf="isFiscalNumberComplete"
                                    translate>sales.fiscalNumber.valid</div>
                                <small class="form-text text-muted" translate>sales.fiscalNumber.hint</small>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-12">
                    <div class="card h-100">
                        <div class="card-header" id="saleDateSection">
                            <h6 class="mb-0">
                                <span translate>sales.saleDateSection</span>
                            </h6>
                        </div>
                        <div id="collapseSaleDateSection" aria-labelledby="saleDateSection">
                            <div class="card-body">
                                <label style="margin-top: 12px;">
                                    <span translate>sales.saleDate</span> <span class="text-danger">*</span>
                                </label>
                                <!-- Readonly throughout: the value is picked from the calendar, never
                                     typed. Without the permission the trigger is disabled too, so the
                                     field shows the moment the sale is being made and nothing else.
                                     [max] stops a sale being dated into a day that has not happened. -->
                                <div class="input-group">
                                    <input class="form-control d-inline" formControlName="saleDate"
                                        [owlDateTime]="saleDatePicker" [max]="maxSaleDate" readonly
                                        [ngClass]="{ 'is-invalid': showValidations && f.saleDate.errors }">
                                    <div class="input-group-append">
                                        <button type="button" [owlDateTimeTrigger]="saleDatePicker"
                                            class="btn btn-outline-secondary fa fa-calendar"
                                            [disabled]="!canEditSaleDate"
                                            (click)="onSaleDatePickerOpen()"></button>
                                    </div>
                                    <owl-date-time [disabled]="!canEditSaleDate" #saleDatePicker></owl-date-time>
                                </div>
                                <div class="invalid-feedback d-block"
                                    *ngIf="showValidations && f.saleDate.errors?.required"
                                    translate>errors.required</div>
                                <small class="form-text text-muted" *ngIf="canEditSaleDate"
                                    translate>sales.saleDate.hint</small>
                                <small class="form-text text-muted" *ngIf="!canEditSaleDate"
                                    translate>sales.saleDate.noPermission</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ******************************************************
            ******************** Сметка за плащане ********************
            ****************************************************** -->
            <div class="card">
                <div class="card-header" id="billSection">
                    <h6 class="mb-0">
                        <span translate>sales.bill</span>
                    </h6>
                </div>
                <div id="collapseBillSection" aria-labelledby="billSection">
                    <div class="card-body">

                        <div class="alert alert-info" *ngIf="billLines.length === 0" translate>sales.bill.empty</div>

                        <div class="table-responsive" *ngIf="billLines.length > 0">
                            <table class="table table-sm">
                                <thead>
                                    <tr>
                                        <th translate>sales.bill.service</th>
                                        <th translate>sales.bill.type</th>
                                        <th translate>sales.bill.quantity</th>
                                        <th translate>sales.bill.price</th>
                                        <th translate>sales.bill.discount</th>
                                        <th translate>sales.bill.total</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let line of billLines">
                                        <td>{{line.name}}</td>
                                        <td>
                                            <span *ngIf="line.kind === 'SERVICE'" translate>sales.bill.type.service</span>
                                            <span *ngIf="line.kind === 'ITEM'" translate>sales.bill.type.item</span>
                                        </td>
                                        <td>{{line.quantity}}</td>
                                        <td>{{lineGross(line) | number:'1.2-2'}}</td>
                                        <td>
                                            <input type="number" min="0" step="0.01" class="form-control form-control-sm"
                                                style="width: 90px;"
                                                [(ngModel)]="line.discount" [ngModelOptions]="{standalone: true}"
                                                (change)="capLineDiscount(line)">
                                        </td>
                                        <td>{{lineTotal(line) | number:'1.2-2'}}</td>
                                        <td>
                                            <button class="btn btn-sm btn-link text-danger" type="button" (click)="removeLine(line)">
                                                <i class="fa fa-times"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="d-flex justify-content-end align-items-center" style="gap: 16px;"
                            *ngIf="billLines.length > 0">
                            <div class="d-flex align-items-center" style="gap: 8px;">
                                <label class="mb-0">
                                    <span translate>sales.paymentType</span> <span class="text-danger">*</span>
                                </label>
                                <select class="custom-select" style="width: auto;" formControlName="paymentTypeId"
                                    [ngClass]="{ 'is-invalid': showValidations && f.paymentTypeId.errors }">
                                    <option *ngFor="let paymentType of paymentTypes" [ngValue]="paymentType.id">
                                        {{paymentType.description}}
                                    </option>
                                </select>
                            </div>
                            <h5 class="mb-0"><span translate>sales.bill.grandTotal</span>: {{grandTotal | number:'1.2-2'}} &euro;</h5>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    </form>

    <div class="d-flex justify-content-end" style="gap: 10px;" *ngIf="dataLoaded">
        <!-- Only when editing: there is nothing to void until the sale exists. Voiding is not an
             edit of what was sold, so it sits apart from the two buttons that save. -->
        <button class="btn btn-outline-danger" type="button" *ngIf="isEdit"
            [disabled]="disableActionBtn" style="margin-top: 10px;" (click)="confirmAnnul()" translate>sales.annul</button>
        <!-- Saves the sale and opens the invoice screen for it. Shares disableActionBtn with
             Запази, so the two cannot race and create two sales. -->
        <button class="btn btn-outline-primary" type="button"
            [disabled]="disableActionBtn" style="margin-top: 10px;" (click)="issueInvoice()" translate>sales.issueInvoice</button>
        <button class="btn btn-primary w-20" type="button"
            [disabled]="disableActionBtn" style="margin-top: 10px;" (click)="save()" translate>button.save</button>
    </div>
</div>

<!-- Voiding cannot be undone from this screen: the sale leaves the list the moment it is done. -->
<ng-template #annulConfirm>
    <h2 mat-dialog-title translate style="font-size: 1.6rem;">button.confirm</h2>
    <mat-dialog-content>
        <p style="font-size: 1.1rem;" translate>sales.annul.confirm</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <div class="text-right">
            <button mat-button [mat-dialog-close]="false" class="btn btn-outline-secondary ml-2 mr-2 mb-1"
                type="button" translate>button.cancel</button>
            <button mat-button [mat-dialog-close]="true" class="btn btn-danger ml-2 mr-2 mb-1"
                type="button" translate>sales.annul</button>
        </div>
    </mat-dialog-actions>
</ng-template>

<ng-template #dataLoadingTemplate>
    <div *ngIf="errorMessage$ | async as errorMessage; else dataSpinner">
        <div class="alert alert-danger">{{errorMessage}}</div>
        <div class="d-flex justify-content-center"><em class="fa fa-refresh" (click)="reload()"></em></div>
    </div>
    <ng-template #dataSpinner>
        <div class="d-flex justify-content-center">
            <div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>
        </div>
    </ng-template>
</ng-template>
